var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "stepOut" }, [
    _c("div", { staticClass: "stepItem" }, [
      _c("p", { class: _vm.stepInfo.status >= 1 ? "blue" : "gray" }, [
        _vm._v("买家下单"),
      ]),
      _c("p", { staticClass: "time" }, [_vm._v(_vm._s(_vm.stepInfo.buyTime))]),
      _vm.stepInfo.status >= 1
        ? _c("div", { staticClass: "stepItem_xian" }, [
            _c("div", { staticClass: "dot" }),
            _c("div", { staticClass: "dot" }),
            _c("div", { staticClass: "dot" }),
            _c("div", { staticClass: "dot" }),
            _c("div", { staticClass: "dot" }),
            _c("div", { staticClass: "dot" }),
          ])
        : _c("div", { staticClass: "stepItem_xian" }, [
            _c("div", { staticClass: "dot1" }),
            _c("div", { staticClass: "dot1" }),
            _c("div", { staticClass: "dot1" }),
            _c("div", { staticClass: "dot1" }),
            _c("div", { staticClass: "dot1" }),
            _c("div", { staticClass: "dot1" }),
          ]),
    ]),
    _c("div", { staticClass: "stepItem shenheStatus" }, [
      _c(
        "p",
        {
          class:
            _vm.stepInfo.status == 2 ||
            _vm.stepInfo.status == 6 ||
            _vm.stepInfo.status == 4 ||
            _vm.stepInfo.status == 3 ||
            _vm.stepInfo.status == 5
              ? "blue"
              : "gray",
        },
        [_vm._v(" 付款成功 ")]
      ),
      _c("p", { staticClass: "time" }, [_vm._v(_vm._s(_vm.stepInfo.payTime))]),
      _vm.stepInfo.status == 2 ||
      _vm.stepInfo.status == 3 ||
      _vm.stepInfo.status == 4 ||
      _vm.stepInfo.status == 5 ||
      _vm.stepInfo.status == 6
        ? _c("div", { staticClass: "stepItem_xian" }, [
            _c("div", { staticClass: "dot" }),
            _c("div", { staticClass: "dot" }),
            _c("div", { staticClass: "dot" }),
            _c("div", { staticClass: "dot" }),
            _c("div", { staticClass: "dot" }),
            _c("div", { staticClass: "dot" }),
          ])
        : _c("div", { staticClass: "stepItem_xian" }, [
            _c("div", { staticClass: "dot1" }),
            _c("div", { staticClass: "dot1" }),
            _c("div", { staticClass: "dot1" }),
            _c("div", { staticClass: "dot1" }),
            _c("div", { staticClass: "dot1" }),
            _c("div", { staticClass: "dot1" }),
          ]),
      _vm.statustype == 3 ? _c("div", { staticClass: "close" }) : _vm._e(),
    ]),
    _c("div", { staticClass: "stepItem" }, [
      _c(
        "p",
        {
          class:
            _vm.stepInfo.status == 5 ||
            (_vm.stepInfo.status == 6 && _vm.stepInfo.status != "99")
              ? "blue"
              : "gray",
        },
        [_vm._v(" 商家发货 ")]
      ),
      _c("p", { staticClass: "time" }, [_vm._v(_vm._s(_vm.stepInfo.postTime))]),
      _vm.stepInfo.status == 5 || _vm.stepInfo.status == 6
        ? _c("div", { staticClass: "stepItem_xian" }, [
            _c("div", { staticClass: "dot" }),
            _c("div", { staticClass: "dot" }),
            _c("div", { staticClass: "dot" }),
            _c("div", { staticClass: "dot" }),
            _c("div", { staticClass: "dot" }),
            _c("div", { staticClass: "dot" }),
          ])
        : _c("div", { staticClass: "stepItem_xian" }, [
            _c("div", { staticClass: "dot1" }),
            _c("div", { staticClass: "dot1" }),
            _c("div", { staticClass: "dot1" }),
            _c("div", { staticClass: "dot1" }),
            _c("div", { staticClass: "dot1" }),
            _c("div", { staticClass: "dot1" }),
          ]),
      _vm.stepInfo.status == 5 || _vm.stepInfo.status == 6
        ? _c("div", { staticClass: "dots" })
        : _vm._e(),
      _vm.stepInfo.status == 5 || _vm.stepInfo.status == 6
        ? _c(
            "div",
            { staticClass: "btn" },
            [
              _c(
                "el-button",
                { staticClass: "whiteBtn", on: { click: _vm.examine } },
                [_vm._v("查看物流")]
              ),
            ],
            1
          )
        : _vm._e(),
    ]),
    _c("div", { staticClass: "stepItem" }, [
      _c("p", { class: _vm.stepInfo.status == 6 ? "blue" : "gray" }, [
        _vm._v("交易完成"),
      ]),
      _c("p", { staticClass: "time" }, [
        _vm._v(_vm._s(_vm.stepInfo.completeTime)),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }